import { Stack } from '@mui/material';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Footer } from '@/components/layout/Footer';
import { Logo } from '@/components/layout/Logo';

const theme = createTheme();

export const Layout: React.FC = ({ children }) => (
  <ThemeProvider theme={theme}>
    <Container maxWidth="sm">
      <Stack sx={{ alignItems: 'center', mt: 6 }}>
        <Logo />
        {children}
        <Footer sx={{ mt: 4, mb: 10 }} />
      </Stack>
    </Container>
  </ThemeProvider>
);
